import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const StyledSection = styled.section`
	display: flex;
	flex-direction: column;
	gap: 12px;
	max-width: 1248px;

	.flex-container {
		display: flex;
		flex-direction: column;
		width: 100%;
		gap: 12px;
	}

	.flex-container-row {
		display: flex;
		flex-direction: column;
		border: 1px black solid;

		${breakPoints({
			'768': `flex-direction: row`,
		})};
	}

	.border-right {
		width: 100%;
		padding: 8px 4px;
		${breakPoints({
			'768': `border-right: 1px black solid;`,
		})};
	}

	.eec-subtitle {
		margin-bottom: 24px;
	}

	.grid-container {
		display: grid;
		gap: 12px;
		padding: 8px 4px;
		border: 1px black solid;
	}
	.two-columns {
		${breakPoints({
			'768': `grid-template-columns: repeat(2, minmax(0, 1fr))`,
		})}
	}

	.key-facts {
		display: flex;
		flex-direction: column;
		row-gap: 4px;

		${breakPoints({
			'768': `flex-direction: row;
                    justify-content: space-between;
				`,
		})};
	}

	.key-facts-long {
		display: flex;
		flex-direction: column;
		gap: 0.25rem;
		${breakPoints({
			'768': `flex-direction: row;
			justify-content: space-between

				`,
		})};
	}

	.list-disc {
		list-style: disc;
		padding-left: 18px;
	}

	.sub-columns {
		display: flex;
		justify-content: space-between;
		align-items: end;

		.-label {
			max-width: 50%;
		}
	}

	a {
		height: auto;
	}

	.footer {
		display: flex;
		justify-content: space-between;

		.date {
			text-align: right;
		}
	}
`;
